import {
    HubConnectionBuilder,
    HttpTransportType,
    LogLevel
} from "@microsoft/signalr";

// Create a SignalR connection instance
const connection = new HubConnectionBuilder()
    .withUrl("/api/hubs/vehiclehub", {
        transport: HttpTransportType.WebSockets,
        withCredentials: true
    })
    .configureLogging(LogLevel.Information)
    .withAutomaticReconnect()
    .build();

// Start the SignalR connection with retry logic
export const startConnection = async() => {
    try {
        await connection.start();
        console.log("✅ SignalR connected to /api/hubs/vehiclehub");
    } catch (error) {
        console.error("❌ SignalR connection failed:", error);
        setTimeout(startConnection, 5000); // Retry after 5 seconds
    }
};

// Register a listener for vehicle location updates
export const onLocationUpdate = (callback) => {
    connection.on("ReceiveLocationUpdate", callback);
};

// Optional: handle connection lifecycle events
connection.onreconnecting((err) => {
    console.warn("⚠️ SignalR reconnecting...", err);
});
connection.onreconnected(() => {
    console.log("🔄 SignalR reconnected");
});
connection.onclose(() => {
    console.warn("❌ SignalR connection closed. Retrying...");
    startConnection();
});

export default connection;